import React, { useState } from "react";
import MainEmp from './Employee/mainEmp'
import MainDepartment from './Department/mainDepartment'
import MainTarget from './Targetssalary/mainTargets'
import AddTarget from "./Targetssalary/mainTargets";

import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import EmployeesTarget from "./Employee/mainEmp";

const button = {
    padding: "16px 20px",
    background: "transparent",
    color: "rgb(100, 116, 139)",
    borderWidth: " medium medium 3px",
    borderStyle: "none none solid",
    borderColor: " currentcolor currentcolor transparent",
    borderImage: "initial",
    fontSize: "15px",
    fontWeight: "500",
    cursor: "pointer",
    transition: "0.2s",
}
const Activebutton = {
    padding: "16px 20px",
    background: "transparent",
    color: "rgb(1, 92, 87)",
    borderWidth: " medium medium 3px",
    borderStyle: "none none solid",
    borderColor: "currentcolor currentcolor rgb(1, 92, 87)",
    borderImage: "initial",
    fontSize: "15px",
    fontWeight: "500",
    cursor: "pointer",
    transition: "0.2s",
}

const TabsExpense = ({ pageViewHandler, admin }) => {
    const [viewState, setViewState] = useState('add')
    const [editData, seteditData] = useState('')


    const BackBtnStyle2 = {
        color: '#fff',
        fontWeight: '400',
        display: 'flex',
        background: '#223d64',
        cursor: 'pointer',
        padding: '12px 20px',
        'boxShadow': 'inset -4px -4px 4px 0px #1d252d'
    }


    return (
        <>
            {/* <div className="row fixed-top" style={{ marginTop: '74px', display: 'flex', width: '100%',marginLeft:'0px',zIndex:'10' }}>
            
                <div className={`expenseListTab ${viewState === 'add'  ? "active" : ""}`} onClick={() => setViewState('add')} style={{  textAlign:'center',borderRadius:'0',background: '#DBE9FF', width:'33.33%' }}>
                    Employees

                </div>
                <div className={`expenseListTab ${viewState === 'department'  ? "active" : ""}`} onClick={() => setViewState('department')}  style={{  textAlign:'center',borderRadius:'0',background: '#DBE9FF', width:'33.33%' }}>
                    Departments

                </div>
                <div className={`expenseListTab ${viewState === 'target'  ? "active" : ""}`} onClick={() => setViewState('target')}  style={{  textAlign:'center',borderRadius:'0',background: '#DBE9FF', width:'33.33%' }}>
                    Targets

                </div>

            </div> */}
            <div className="container-fluid">
                <div className="row fixed-top" style={{ marginTop: '74.5px', display: 'flex', width: '100%', zIndex: '10', background: "rgb(248, 250, 252)", borderBottom: "1px solid rgb(226, 232, 240)" ,justifyContent:'end'}}>
                    <button style={viewState == "add" ? Activebutton : button} onClick={() => setViewState('add')}>Employees</button>

                    <button style={viewState == "department" ? Activebutton : button} onClick={() => setViewState('department')}> Departments</button>
                    <button style={viewState == "target" ? Activebutton : button} onClick={() => setViewState('target')}>Targets</button>
                </div>
            </div>
            <div className="" style={{ marginTop: window.innerWidth > 1800 ? '4%' : '7%' }}>

                {viewState === 'add' ?
                    <EmployeesTarget showButton={true} editData={editData} admin={admin} />
                    : ""}
                {viewState === 'department' ?
                    <MainDepartment showButton={true} editData={editData} admin={admin} />
                    : ""}
                {viewState === 'target' ?
                    <AddTarget showButton={true} editData={editData} admin={admin} />
                    : ""}
            </div>
        </>
    )
}
export default TabsExpense